import { configureStore } from '@reduxjs/toolkit';
import { apiSlice } from './apiSlice';
import episodeListReducer from "../../src/components/pages/EpisodeList/redux/EpisodeListSlicer"
import documentViewerReducer from "../../src/components/DocumentViewer/redux/DocumentViewerSlicer"
import CodeBookReducer from '../../src/components/CodeBook/redux/CodeBookSlicer';
import coderReducer from "../../src/components/pages/Coder/redux/CoderSlicer"
import codeAssistReducer from "../../src/components/CodeAssist/redux/CodeAssistSlicer"
import codingScreenSlice from "../../src/store/CodingScreenSlice"
import codeSearchReducer from "../components/CodeAssist/CodeSearch/redux/codeSearchSlice";
import queueReducer from "../store/queueSlice";
import userQueueReducer from "../store/userSlice";
import coderScreenReducer from "../components/Codeworkflow/CoderView/redux/CoderScreenSlice"
import auditorViewReducer from "../../src/components/Codeworkflow/AuditorView/redux/AuditorViewSlicer"
import codeWorkflowReducer from "../../src/components/Codeworkflow/CodeworkflowSlicer"
import outstandingReportReducer from "../../src/components/Codeworkflow/Reports/redux/ReportsSlice"
import codieStateofHomepageReducer from "../components/HomePage/redux/HomePageSlice"
import healthInsuranceManager from "../../src/components/Codeworkflow/HealthInsuranceManager/redux/HealthInsuranceManagerSlicer"
import grouperSettingsReducer from '../components/grouperSettings/GrouperSettingsSlice';
export const store = configureStore({
    reducer: {
        [apiSlice.reducerPath]: apiSlice.reducer, // Add RTK Query reducer
        episodeList: episodeListReducer,
        auditorView: auditorViewReducer,
        documentViewer: documentViewerReducer,
        codeBook:CodeBookReducer,
        coder: coderReducer,
        healthInsuranceManager: healthInsuranceManager,
        codeAssist: codeAssistReducer,
        codingScreen: codingScreenSlice,
        codeSearch: codeSearchReducer,
        queue: queueReducer,
        userQueue: userQueueReducer,
        coderscreenqueue: coderScreenReducer,
        codeWorkflow: codeWorkflowReducer,
        outstandingreport:outstandingReportReducer,
        codieStateofHomepage:codieStateofHomepageReducer,
        grouperSettings:grouperSettingsReducer

    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(apiSlice.middleware), // Add middleware for API caching
});
